/**
 * MEDIA-VIEWER.JS
 */

import lightGallery from "lightgallery";
import lgVideo from "lightgallery/plugins/video";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-video.css";

export default class MediaViewer {

	static init() {
		return new MediaViewer();
	}

	constructor() {
		const lightGalleries = document.querySelectorAll(".media-viewer");
		if (lightGalleries.length === 0) return;

		lightGalleries.forEach((gallery) => {
			lightGallery(gallery, {
				selector: ".media-viewer-item",
				licenseKey: atob("SEo3S04tU1RHUjctUjhLR0YtQ1UzVzM="),
				plugins: [lgVideo],
				download: false,
				mobileSettings: {
					showCloseIcon: true,
					download: false,
				},
			});
		});
	}
}
